<template>
  <section>
    <Banner value="Seguro dos alunos" />
    <hr style="border:5px solid #DDD" />

    <section style="background:#DDD">
      <v-container grid-list-xl>
        <v-layout row wrap my-4>
          <v-flex xs12>
            <p class="lead">
              Preocupada com a segurança e o bem-estar de seus alunos a Escola
              Engenho oferece SEGURO DE ACIDENTES PESSOAIS. Nenhum custo
              adicional é cobrado e todos os estudantes podem contar com
              cobertura 24 horas até mesmo para acidentes que venham a acontecer
              fora da nossa escola. Este seguro é automaticamente contratado no
              ato da matrícula e dá direito ao reembolso de despesas de
              acidentes até o valor de R$ 10.000,00 por evento.
            </p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section style="background:none;">
      <v-container grid-list-xl>
        <v-layout row wrap my-4>
          <v-flex md6>
            <h3>Características do seguro:</h3>
            <ol>
              <li>
                Os beneficiários (estudantes da Escola Engenho) estarão cobertos
                24 (vinte e quatro) horas por dia e 7 (sete) dias na semana – em
                caso de Acidentes (de qualquer espécie);
              </li>
              <li>
                Os estudantes estarão cobertos independentemente de onde tenha
                ocorrido o acidente, ou seja, dentro e fora das dependências da
                escola;
              </li>
              <li>
                Além das “Despesas Médico-Hospitalares e Odontológicas”, também
                estão cobertos os gastos com fisioterapia e medicamentos,
                decorrentes do acidente sofrido pelo estudante;
              </li>
              <li>
                A primeira carteira de beneficiário (aluno) será fornecida de
                forma gratuita, porém, em caso de perda ou extravio, será
                cobrado um valor de R$ 20,00 (vinte reais), para a emissão da
                segunda via;
              </li>
              <li>
                Em caso de acidentes, é necessário ligar para a central, através
                do telefone 3003-5433 - opção 1 e depois opção 4, informando o
                nome da escola, para que a ocorrência seja registrada e o aluno
                tenha o seu atendimento médico direcionado;
              </li>
              <li>
                Havendo uma rede credenciada na localidade, os atendimentos
                somente poderão ser realizados fora dessa rede em casos
                excepcionais e justificáveis.
              </li>
              <li>
                Para o reembolso de gastos realizados fora da rede credenciada,
                os documentos listados abaixo deverão ser entregues na Escola
                Engenho no prazo máximo de 72 (setenta e duas) horas.
              </li>
            </ol>
          </v-flex>
          <v-flex md6>
            <h3>O que fazer em caso de acidente pessoal escolar:</h3>
            <img
              src="/images/seguro3.jpg"
              alt="Rocha Seguros"
              style="width:100%; margin-top:15px;"
            />
            <p>
              Para poder usufruir do benefício, faz-se necessário o primeiro
              contato (no momento do acidente) com o serviço de atendimento
              pelos telefones abaixo através dos quais os pais serão informados
              dos procedimentos posteriores.
            </p>
            <v-layout>
              <v-flex xs12>
                <v-btn href="tel:3003 5433" large round block color="blue" dark>
                  <v-icon>local_phone</v-icon>3003 5433
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section style="background:none">
      <v-container grid-list-xl>
        <v-layout row wrap my-4>
          <v-flex md6>
            <h3>
              Documentos necessários para reembolso em caso de despesas médicas,
              hospitalares e odontológicas:
            </h3>
            <ol>
              <li>Aviso de Acidente Inicial preenchido na escola;</li>
              <li>Relatório Médico Assistente preenchido pelo médico;</li>
              <li>Cópia da certidão de nascimento, RG e CPF do estudante;</li>
              <li>Cópia do RG e CPF do responsável pelo menor;</li>
              <li>Boletim de Ocorrência (BO), quando for o caso;</li>
              <li>Comprovante de residência atualizado;</li>
              <li>
                Cópia do contrato escola x estudante ou declaração de matrícula;
              </li>
              <li>
                Todos os comprovantes e Notas Fiscais de despesas provenientes
                de consultas, exames, fisioterapia, tratamento odontológico (por
                acidente), medicamentos, cirurgia, deverão ser originais;
              </li>
              <li>Nota Fiscal da farmácia, acompanhada da receita médica;</li>
              <li>
                Quando realizados exames, é necessário o envio do pedido médico;
                (Exemplo: Raio-X, Ressonância Magnética etc.);
              </li>
              <li>
                Quando necessária a realização de fisioterapia, o pedido médico
                e a assinatura na ficha de presença das sessões realizadas.
              </li>
            </ol>
            <br />
            <p class="body-1">
              Portanto, quando ocorrer algum sinistro, ajude-nos enviando a
              documentação necessária completa para agilizarmos o reembolso das
              despesas e assim podermos garantir um atendimento de qualidade.
            </p>
          </v-flex>

          <v-flex md6>
            <h3>
              Relembramos algumas características do seguro, encaminhadas no ato
              da matrícula:
            </h3>
            <ol>
              <li>
                Os estudantes estarão cobertos independentemente de onde tenha
                ocorrido o acidente, ou seja, dentro e fora das dependências da
                escola;
              </li>
              <li>
                A primeira carteira de beneficiário (aluno) será fornecida de
                forma gratuita; porém, em caso de perda ou extravio, será
                cobrada uma taxa de R$ 20,00 (vinte reais) para a emissão
                da segunda via;
              </li>
              <li>
                Para o reembolso de gastos realizados fora da rede credenciada,
                os documentos necessários deverão ser entregues na
                <b
                  >Escola Engenho no prazo máximo de 72 (setenta e duas)
                  horas.</b
                >
              </li>
            </ol>
            <br />
            <p>
              O cartão do seguro de acidentes pessoais dos alunos fica
              disponível na escola, podendo ser retirado somente pelo
              responsável do aluno(a), na secretaria.
            </p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </section>
</template>

<script>
import Banner from "../../components/Banner";

export default {
  data: () => ({}),
  components: {
    Banner
  }
};
</script>

<style lang="scss" scoped>
p,
h2,
ul li,
ol li {
  text-align: justify !important;
}
ul li,
ol li {
  margin-top: 10px;
}
</style>
